// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CompanyEmployeesSearchRequestDto } from '../models';
// @ts-ignore
import type { CompanyEmployeesSearchResponseDto } from '../models';
// @ts-ignore
import type { CompanyEmployeesSortValueDto } from '../models';
// @ts-ignore
import type { DictionaryLanguageDto } from '../models';
// @ts-ignore
import type { SortDirectionDto } from '../models';
/**
 * CompanyEmployeesSearchRestApi - axios parameter creator
 */
export const CompanyEmployeesSearchRestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} companyId 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {SortDirectionDto} sortDirection 
         * @param {CompanyEmployeesSortValueDto} companyEmployeesSort 
         * @param {DictionaryLanguageDto} language 
         * @param {CompanyEmployeesSearchRequestDto} companyEmployeesSearchRequestDto Find company employees request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCompanyEmployees: async (companyId: string, page: number, pageSize: number, sortDirection: SortDirectionDto, companyEmployeesSort: CompanyEmployeesSortValueDto, language: DictionaryLanguageDto, companyEmployeesSearchRequestDto: CompanyEmployeesSearchRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('searchCompanyEmployees', 'companyId', companyId)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('searchCompanyEmployees', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('searchCompanyEmployees', 'pageSize', pageSize)
            // verify required parameter 'sortDirection' is not null or undefined
            assertParamExists('searchCompanyEmployees', 'sortDirection', sortDirection)
            // verify required parameter 'companyEmployeesSort' is not null or undefined
            assertParamExists('searchCompanyEmployees', 'companyEmployeesSort', companyEmployeesSort)
            // verify required parameter 'language' is not null or undefined
            assertParamExists('searchCompanyEmployees', 'language', language)
            // verify required parameter 'companyEmployeesSearchRequestDto' is not null or undefined
            assertParamExists('searchCompanyEmployees', 'companyEmployeesSearchRequestDto', companyEmployeesSearchRequestDto)
            const localVarPath = `/api/v1/companies/{companyId}/employees/search`
                .replace('{companyId}', encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (companyEmployeesSort !== undefined) {
                localVarQueryParameter['companyEmployeesSort'] = companyEmployeesSort;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(companyEmployeesSearchRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompanyEmployeesSearchRestApi - functional programming interface
 */
export const CompanyEmployeesSearchRestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CompanyEmployeesSearchRestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} companyId 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {SortDirectionDto} sortDirection 
         * @param {CompanyEmployeesSortValueDto} companyEmployeesSort 
         * @param {DictionaryLanguageDto} language 
         * @param {CompanyEmployeesSearchRequestDto} companyEmployeesSearchRequestDto Find company employees request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchCompanyEmployees(companyId: string, page: number, pageSize: number, sortDirection: SortDirectionDto, companyEmployeesSort: CompanyEmployeesSortValueDto, language: DictionaryLanguageDto, companyEmployeesSearchRequestDto: CompanyEmployeesSearchRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyEmployeesSearchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchCompanyEmployees(companyId, page, pageSize, sortDirection, companyEmployeesSort, language, companyEmployeesSearchRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyEmployeesSearchRestApi.searchCompanyEmployees']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CompanyEmployeesSearchRestApi - factory interface
 */
export const CompanyEmployeesSearchRestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CompanyEmployeesSearchRestApiFp(configuration)
    return {
        /**
         * 
         * @param {string} companyId 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {SortDirectionDto} sortDirection 
         * @param {CompanyEmployeesSortValueDto} companyEmployeesSort 
         * @param {DictionaryLanguageDto} language 
         * @param {CompanyEmployeesSearchRequestDto} companyEmployeesSearchRequestDto Find company employees request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCompanyEmployees(companyId: string, page: number, pageSize: number, sortDirection: SortDirectionDto, companyEmployeesSort: CompanyEmployeesSortValueDto, language: DictionaryLanguageDto, companyEmployeesSearchRequestDto: CompanyEmployeesSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CompanyEmployeesSearchResponseDto> {
            return localVarFp.searchCompanyEmployees(companyId, page, pageSize, sortDirection, companyEmployeesSort, language, companyEmployeesSearchRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CompanyEmployeesSearchRestApi - interface
 */
export interface CompanyEmployeesSearchRestApiInterface {
    /**
     * 
     * @param {string} companyId 
     * @param {number} page 
     * @param {number} pageSize 
     * @param {SortDirectionDto} sortDirection 
     * @param {CompanyEmployeesSortValueDto} companyEmployeesSort 
     * @param {DictionaryLanguageDto} language 
     * @param {CompanyEmployeesSearchRequestDto} companyEmployeesSearchRequestDto Find company employees request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchCompanyEmployees(companyId: string, page: number, pageSize: number, sortDirection: SortDirectionDto, companyEmployeesSort: CompanyEmployeesSortValueDto, language: DictionaryLanguageDto, companyEmployeesSearchRequestDto: CompanyEmployeesSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CompanyEmployeesSearchResponseDto>;

}

/**
 * CompanyEmployeesSearchRestApi - object-oriented interface
 */
export class CompanyEmployeesSearchRestApi extends BaseAPI implements CompanyEmployeesSearchRestApiInterface {
    /**
     * 
     * @param {string} companyId 
     * @param {number} page 
     * @param {number} pageSize 
     * @param {SortDirectionDto} sortDirection 
     * @param {CompanyEmployeesSortValueDto} companyEmployeesSort 
     * @param {DictionaryLanguageDto} language 
     * @param {CompanyEmployeesSearchRequestDto} companyEmployeesSearchRequestDto Find company employees request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchCompanyEmployees(companyId: string, page: number, pageSize: number, sortDirection: SortDirectionDto, companyEmployeesSort: CompanyEmployeesSortValueDto, language: DictionaryLanguageDto, companyEmployeesSearchRequestDto: CompanyEmployeesSearchRequestDto, options?: RawAxiosRequestConfig) {
        return CompanyEmployeesSearchRestApiFp(this.configuration).searchCompanyEmployees(companyId, page, pageSize, sortDirection, companyEmployeesSort, language, companyEmployeesSearchRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

